import React from 'react';
import graphql from 'graphql';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';

const CapabilitiesPage = ({ data }) => (
  <div>
    <Helmet title={`Capabilities Offered | ${data.site.siteMetadata.title}`} />
    <h1>Capabilities page</h1>
    {data.allFile &&
      data.allFile.edges.map(({ node }) => (
        <Link key={node.name} to={`${node.relativeDirectory}/${node.name}`}>
          {node.name}
        </Link>
      ))}
  </div>
);

export default CapabilitiesPage;

export const CapabilitiesPageQuery = graphql`
  query CapabilitiesPageQuery {
    site {
      siteMetadata {
        title
      }
    }
    allFile(filter: { relativeDirectory: { eq: "capabilities" }, name: { ne: "index" } }) {
      edges {
        node {
          name
          relativePath
          relativeDirectory
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/capabilities/index.jsx